export const _ADD               = "aYWwpTM9HaXPu+8DwfxbgQ==";
export const _EDIT              = "jPd4fnX0Z8SuvI61CtWqVA==";
export const _VIEW              = "w8YSSVLbDYNeYw9vxfR7zw==";
export const _DELETE            = "9tZDA0dTUaicr2TJ0gJHhQ==";
export const _RECOVER           = "2veMy6xX98KdUbW32H+cHA==";
export const _LIST              = "PqhVRpJN3oissdQBD+xCsA==";
export const _TRASH             = "0odLAR4+3WZQBSOXx3tMvw==";